import { CargoKanbanCase } from '../../../../../business/cargo';
import { useCargoContext } from '../../../context';

export function useCancelDialog() {
  const {
    data: { isOpenCancelDialog, selectedOrder },
    setCloseCancelDialog,
  } = useCargoContext();
  const {
    cancelCost,
    cancelOrder,
    isCancelCargoOrderLoading,
    isCancelCostLoading,
  } = CargoKanbanCase();

  const closeDialog = () => setCloseCancelDialog();

  function onCancelCargoOrder() {
    cancelOrder({ orderId: selectedOrder });
    setCloseCancelDialog();
  }

  return {
    closeDialog,
    cancelOrderDialog: { isOpen: isOpenCancelDialog, orderId: selectedOrder },
    cancelCost,
    isCancelCostLoading,
    isCancelCargoOrderLoading,
    onCancelCargoOrder,
  };
}
